import { useController } from '@framework/form/hooks/useController.ts';
import { EngineInternalFieldSuffix } from '../../../../../expressions/EngineInternalFieldSuffix.ts';
import { type IWidgetComponentProps } from '../../../../IWidgetType.ts';
import { type IWidgetParsedProps } from '../../../inputs/common/util/getWidgetProps.ts';
import { type ISubsectionWidget } from '../ISubsectionWidget.ts';
import { SubsectionDrawer } from './main-layout/SubsectionDrawer.tsx';

export function getHiddenSubsectionControlFieldName(name: string) {
  return `${EngineInternalFieldSuffix}_${name}_hidden_field_controller`;
}

export interface IHiddenSubsectionComponentProps
  extends IWidgetComponentProps<ISubsectionWidget> {
  options: IWidgetParsedProps;
}

export function HiddenSubsectionComponent(
  props: IHiddenSubsectionComponentProps,
) {
  const { widget, options } = props;

  const { field } = useController(
    getHiddenSubsectionControlFieldName(options.name),
  );

  return (
    <SubsectionDrawer
      {...props}
      widget={widget}
      isOpen={field.value}
      setIsOpen={(value: boolean) => {
        field.onChange(value);
      }}
    />
  );
}
